<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    type: {
      type: String,
      default: 'a',
      validator(value) {
        return ['a', 'b'].includes(value)
      },
    },
  },
  data() {
    return {
      activeMenu: 0,
      activeProductMenu: 0,
    }
  },
  computed: {
    activeCategoryAlias() {
      return this.list[this.activeMenu].alias
    },
  },
  methods: {
    toUpperCasefirst(str) {
      const strarr = str.split(' ')
      let result = ''

      for (let i in strarr) {
        result = `${strarr[i].substring(0, 1).toUpperCase()}${strarr[i].substring(1)}`
      }

      return result
    },
    handleClickSolution(filterClass) {
      this.$router.push({
        name: 'solution-list',
        query: {
          filterCategory: this.activeCategoryAlias,
          filterClass,
        },
      })
    },
    handleClickProduct(filterBrand) {
      this.$router.push({
        name: 'product-list',
        query: {
          filterCategory: this.list[this.activeMenu].data.list[this.activeProductMenu].alias,
          filterBrand,
        },
      })
    },
    goToFilter({ alias, brands, title }) {
      const router = () => {
        switch (this.list[this.activeMenu].to.name) {
          case 'brand-list':
            return {
              name: 'brand-list',
              query: {
                filterClass: alias,
              },
            }
          case 'product-list':
            return {
              name: 'product-list',
              query: {
                filterCategory: alias,
              },
            }
        }
      }
      this.$router.push({
        ...router(),
      })
    },
  },
}
</script>
<template>
  <div :class="[$style.megaMenu, $style[`isStyle${toUpperCasefirst(type)}`]]">
    <div class="d-flex">
      <div class="megaMenu__left">
        <BaseMenu v-model="activeMenu" :title="title" :list="list" class="megaMenu__menu" type="holderHover" />
      </div>
      <template v-if="type === 'a' && list[activeMenu] && list[activeMenu].data">
        <template v-if="list[activeMenu].alias === 'products'">
          <div class="megaMenu__left ml-0">
            <BaseMenu v-model="activeProductMenu" title="產品分類" :list="list[activeMenu].data.list" class="megaMenu__menu isGrayLight point isDownMark" type="holderHover" @clickMenu="goToFilter" />
          </div>
          <div class="megaMenu__right">
            <BaseSectionTitle2 class="megaMenu__title" title="品牌總覽"> </BaseSectionTitle2>
            <div>
              <ul v-if="list[activeMenu].data.list[activeProductMenu]" class="megaMenu__menuList row mt-2">
                <li v-for="(menuItem, index) in list[activeMenu].data.list[activeProductMenu].brands" :key="`${menuItem}-${index}`" class="megaMenu__menuList__item col-2xl-6 col-12">
                  <BaseButton
                    :to="{
                      name: 'product-list',
                      query: {
                        filterBrand: menuItem.alias,
                        filterCategory: list[activeMenu].data.list[activeProductMenu].alias,
                      },
                    }"
                    class="megaMenu__menuList__link isStyleGrayLight isRadius isSmall isFull"
                  >
                    {{ menuItem.title }}
                  </BaseButton>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template v-if="list[activeMenu].alias === 'brands'">
          <div class="megaMenu__right">
            <BaseSectionTitle2 class="megaMenu__title" title="品牌總覽"> </BaseSectionTitle2>
            <div>
              <ul class="megaMenu__menuList row mt-2">
                <li v-for="(menuItem, index) in list[activeMenu].data.list" :key="`${menuItem}-${index}`" class="megaMenu__menuList__item col-xl-4 col-lg-6 col-12">
                  <BaseButton
                    :to="{
                      name: 'brand-item',
                      params: {
                        brandAlias: menuItem.alias,
                      },
                    }"
                    class="megaMenu__menuList__link isStyleGrayLight isRadius isSmall isFull"
                  >
                    {{ menuItem.title }}
                  </BaseButton>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </template>
      <template v-if="type === 'b' && list[activeMenu]">
        <div class="megaMenu__right">
          <div v-if="list[activeMenu].alias" class="mb-5">
            <div class="megaMenu__title mb-4">
              {{ list[activeMenu].title }}
            </div>
            <p class="megaMenu__description">
              {{ list[activeMenu].description }}
            </p>
          </div>
          <div>
            <div class="megaMenu__title mb-4">
              提供產業別
            </div>
            <ul class="megaMenu__menuList row">
              <li v-for="(menuItem, index) in list[activeMenu].industry_category" :key="`${menuItem}-${index}`" class="megaMenu__menuList__item  col-xl-6 col-12">
                <BaseButton :to="menuItem.to" class="megaMenu__menuList__link isStyleGrayLight isRadius isSmall isFull" @click="handleClickSolution(menuItem.alias)">
                  {{ menuItem.title }}
                </BaseButton>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" module>
.megaMenu {
  height: 520px;

  &.isStyleA {
    :global {
      .megaMenu {
        &__menuList {
          margin: -0.625rem -1.25rem;

          &__item {
            padding: 0.625rem 1.25rem;

            &.col-2xl-6 {
              @media screen and (min-width: 1500px) {
                flex: 0 0 50%;
                max-width: 50%;
              }
            }
          }

          &__link {
            display: block;
            padding-top: 1rem;
            padding-bottom: 1rem;
            color: $color-gray-7;
            letter-spacing: 0;

            &:hover {
              // color: $color-gray-6;
              text-decoration: none;
            }
          }
        }

        &__right {
          @include max-xl {
            padding: 2.5rem 3.625rem;
          }
        }
      }
    }
  }

  &.isStyleB {
    :global {
      .megaMenu {
        &__menuList {
          margin: -0.625rem -2.875rem;

          @media screen and (max-width: 1500px) {
            margin-right: -0.625rem;
            margin-left: -0.625rem;
          }

          &__item {
            padding: 0.625rem 2.875rem;

            @media screen and (max-width: 1500px) {
              padding: 0.625rem;
            }

            @media screen and (min-width: 1500px) {
              flex: 0 0 33.33333%;
              max-width: 33.33333%;
            }
          }

          &__link {
          }
        }
      }
    }
  }

  :global {
    .megaMenu {
      &__left {
        flex: none;
        width: 383px;
        height: 520px;
        padding: 2.5rem 0;
        overflow-y: auto;
        // margin-left: calc(0 - ((100vw - #{$container-menu}) / 2));

        @media screen and (min-width: 1980px) {
          margin-left: -$container-gap;
        }

        @media screen and (max-width: #{$container-menu + ($container-gap * 2)}) {
          margin-left: -$container-gap;
        }

        @include max-xl {
          width: 350px;
        }

        @media screen and (max-width: #{$container + ($container-gap * 2)}) {
          width: 330px;
        }
      }

      &__right {
        flex-grow: 1;
        height: 520px;
        padding: 2.5rem 8.625rem;
        margin-right: -80px;
        overflow-y: auto;

        @media screen and (min-width: 1980px) {
          margin-right: -$container-gap;
        }

        @media screen and (max-width: #{$container-menu + ($container-gap * 2)}) {
          margin-right: -$container-gap;
        }

        @include max-xl {
          padding: 2.5rem 5.625rem;
        }

        @media screen and (max-width: #{$container + ($container-gap * 2)}) {
          padding: 2.5rem 3.625rem;
        }
      }

      &__title {
        margin-bottom: 3rem;
        font-size: 1.25rem;
        font-weight: 500;

        &.isStyleUnderLine {
          position: relative;
          display: inline-block;

          &::before {
            position: absolute;
            bottom: -20px;
            left: 20px;
            width: 30px;
            height: 5px;
            content: '';
            background-color: #abcd03;
            border-radius: 4px;
          }

          &::after {
            position: absolute;
            bottom: -20px;
            left: 10px;
            width: 5px;
            height: 5px;
            content: '';
            background-color: #abcd03;
            border-radius: 50%;
            box-shadow: -9px 0 0 #abcd03;
          }
        }
      }

      &__description {
        font-size: 1rem;
        color: $color-gray-6;
      }

      &__menu {
        height: 520px;
        margin: -2.5rem 0;
        overflow: auto;
      }

      &__menuList {
        @include list-unstyled;
      }

      &.isStyleA {
        .megaMenu {
          &__menuList {
            &__item {
            }

            &__link {
              display: block;
              padding-top: 1rem;
              padding-bottom: 1rem;
              color: $color-gray-6;

              &:hover {
                color: $color-primary;
                text-decoration: none;
              }
            }
          }
        }
      }

      &.isStyleB {
        .megaMenu {
          &__menuList {
            margin: -0.625rem -2.875rem;
            border-radius: 5px;

            &__item {
              padding: 0.625rem 2.875rem;
            }

            &__link {
            }
          }
        }
      }
    }
  }
}
</style>
